// Kept apart from ticketTypeSalesPause so a view can show the copy without loading the API client.
export const SALES_PAUSED_TITLE = 'Sales paused';
export const SALES_PAUSED_DETAIL = "Fans can't buy this ticket online or through partners, and anyone partway through checkout is stopped. Your box office can still sell it. Resume sales from the ⋮ menu.";
export const SALES_PAUSED_DESCRIPTION = `${SALES_PAUSED_TITLE}. ${SALES_PAUSED_DETAIL}`;
